export const NO_USER_AUTH = "auth/NO_USER_AUTH";
export const AUTH_USER = "auth/AUTH_USER";
export const AUTH_2FA_USER = "auth/AUTH_2FA_USER";
export const UNAUTH_USER = "auth/UNAUTH_USER";
export const CONTACT_USER = "auth/CONTACT_USER";
export const USER_ORG_REQUIRES_SESSION_PWD = "auth/USER_ORG_REQUIRES_SESSION_PWD";
export const INIT_VISITOR_ID = "auth/INIT_VISITOR_ID";
export const UPDATE_AVIARY_TOKENS = "auth/UPDATE_AVIARY_TOKENS";
export const SWITCH_ORG = "auth/SWITCH_ORG";

export const PERSON = "PERSON";
export const QUESTION = "QUESTION";
export const TAG = "TAG";
export const EMAIL = "EMAIL";
export const SUBMIT_STORY_CONCLUDE = "SUBMIT_STORY_CONCLUDE";

export const PROJECT_INVITE = "PROJECT_INVITE";
export const PROJECTS_RESET_CURRENT = "PROJECTS_RESET_CURRENT";
export const PROJECTS_RESET_STORIES = "PROJECTS_RESET_STORIES";
export const PROJECTS_RESET_USER_PROJECTS = "PROJECTS_RESET_USER_PROJECTS";
export const PROJECTS_LOADING = "PROJECTS_LOADING";
export const PROJECTS_LOADED = "PROJECTS_LOADED";
export const PROJECT_LOADED = "PROJECT_LOADED";
export const PROJECT_STORIES_SET_PAGE_VIEW = "PROJECT_STORIES_SET_PAGE_VIEW";
export const PROJECT_STORIES_SORT_SETTING = "PROJECT_STORIES_SORT_SETTING";
export const PROJECT_STORIES_LOADING = "PROJECT_STORIES_LOADING";
export const PROJECT_STORIES_LOADED = "PROJECT_STORIES_LOADED";
export const PROJECT_DETAILS_LOADED = "PROJECT_DETAILS_LOADED";
export const PROJECT_STORIES_PARTIAL_UPDATE = "PROJECT_STORIES_PARTIAL_UPDATE";
export const PROJECT_STORY_TASK_UPDATED = "PROJECT_STORY_TASK_UPDATED";
export const PROJECT_TABLE_STORY_UPDATE = "PROJECT_TABLE_STORY_UPDATE";
export const PROJECT_UPLOADING_FILES = "PROJECT_UPLOADING_FILES";
export const PROJECT_UPLOADING_SET_FILES = "PROJECT_UPLOADING_SET_FILES";
export const PROJECT_UPLOADING_SET_PROGRESS_LOCAL_FILES = "PROJECT_UPLOADING_SET_PROGRESS_LOCAL_FILES";
export const PROJECT_UPLOADING_SET_PROGRESS_CLOUD_FILES = "PROJECT_UPLOADING_SET_PROGRESS_CLOUD_FILES";
export const PROJECT_UPLOADING_SET_COMPLETE_LOCAL_FILES = "PROJECT_UPLOADING_SET_COMPLETE_LOCAL_FILES";
export const PROJECT_UPLOADING_BULK_UPDATE_FILES = "PROJECT_UPLOADING_BULK_UPDATE_FILES";
export const PROJECT_UPLOADING_HYDRATE_METADATA = "PROJECT_UPLOADING_HYDRATE_METADATA";
export const PROJECT_UPLOADING_DELETE_FILES = "PROJECT_UPLOADING_DELETE_FILES";
export const PROJECT_SET_STORIES_TO_DELETE = "PROJECT_SET_STORIES_TO_DELETE";
export const PROJECT_SET_NEED_TO_DELETE_FLAG = "PROJECT_SET_NEED_TO_DELETE_FLAG";
export const GET_UPDATE_FILES = "GET_UPDATE_FILES";
export const ADD_FILE = "ADD_FILE";

export const PROJECT_UPLOADING_LOCAL_FILES = "PROJECT_UPLOADING_LOCAL_FILES";
export const PROJECT_UPLOADING_PROGRESS_LOCAL_FILES = "PROJECT_UPLOADING_PROGRESS_LOCAL_FILES";
export const PROJECT_UPLOADING_ENCODING_LOCAL_FILES = "PROJECT_UPLOADING_ENCODING_LOCAL_FILES";

export const PROJECT_TABLE_STORIES_SET_PAGE_VIEW = "PROJECT_TABLE_STORIES_SET_PAGE_VIEW";
export const PROJECT_TABLE_STORIES_LOADING = "PROJECT_TABLE_STORIES_LOADING";
export const PROJECT_TABLE_STORIES_LOADED = "PROJECT_TABLE_STORIES_LOADED";

export const FOLDERS_LOADED = "FOLDERS_LOADED";
export const FOLDERS_LOADING = "FOLDERS_LOADING";
export const FOLDERS_RESET_CURRENT = "FOLDERS_RESET_CURRENT";
export const RESET_FOLDER_STATE = "RESET_FOLDER_STATE";
export const RESET_FOLDER_STORIES = "RESET_FOLDER_STORIES";
export const FOLDER_LOADED = "FOLDER_LOADED";
export const FOLDER_STORIES_SET_PAGE_VIEW = "FOLDER_STORIES_SET_PAGE_VIEW";
export const FOLDER_STORIES_LOADING = "FOLDER_STORIES_LOADING";
export const FOLDER_STORIES_SORT_SETTING = "FOLDER_STORIES_SORT_SETTING";
export const FOLDER_STORIES_LOADED = "FOLDER_STORIES_LOADED";
export const FOLDER_DETAILS_LOADED = "FOLDER_DETAILS_LOADED";
// export const FOLDER_SEARCH_PARAM = "FOLDER_SEARCH_PARAM";
export const FOLDER_STORIES_PARTIAL_UPDATE = "FOLDER_STORIES_PARTIAL_UPDATE";
export const FOLDER_STORY_TASK_UPDATED = "FOLDER_STORY_TASK_UPDATED";
export const FOLDERS_TOGGLE_CREATE_FOLDER_MODAL = "FOLDERS_TOGGLE_CREATE_FOLDER_MODAL";

export const STORIES_LOADING = "STORIES_LOADING";
export const STORIES_LOADED = "STORIES_LOADED";
export const STORIES_LOAD_FAILED = "STORIES_LOAD_FAILED";
export const STORIES_ONE_UPDATED = "STORIES_ONE_UPDATED";
export const STORIES_PARTIAL_UPDATE = "STORIES_PARTIAL_UPDATE";
export const STORIES_SET_PAGE_VIEW = "STORIES_SET_PAGE_VIEW";
export const STORIES_CLEAR = "STORIES_CLEAR";
export const STORIES_SORT_SETTING = "STORIES_SORT_SETTING";
export const STORIES_TOGGLE_SELECTED_STORY = "STORIES_TOGGLE_SELECTED_STORY";
export const STORIES_CLEAR_SELECTED_STORIES = "STORIES_CLEAR_SELECTED_STORIES";
export const STORY_TASK_UPDATED = "STORY_TASK_UPDATED";
export const STORIES_GALLERY_FILTERS_LOADED = "STORIES_GALLERY_FILTERS_LOADED";
export const STORIES_GALLERY_FILTER_LOADED = "STORIES_GALLERY_FILTER_LOADED";

// INTERVIEWS/PREPARED SESSIONS
export const PREPSESSION_LOADED = "PREPSESSION_LOADED";
export const PREPSESSIONS_LOADED = "PREPSESSIONS_LOADED";
export const PREPSESSIONS_STORIES_SET_PAGE_VIEW = "PREPSESSIONS_STORIES_SET_PAGE_VIEW";
export const PREPSESSION_CLEAR = "PREPSESSION_CLEAR";

// TRANSCRIPTS STATUS
export const TRANSCRIPT_EMPTY = "empty";
export const TRANSCRIPT_BEGIN = "pending";
export const TRANSCRIPT_SUCCESS = "completed";
export const TRANSCRIPT_ERROR = "failed";

// WAV STATUS
export const WAV_EMPTY = "empty";
export const WAV_BEGIN = "pending";
export const WAV_SUCCESS = "completed";
export const WAV_ERROR = "failed";

export const WATCH_CALL_STATE = "WATCH_CALL_STATE";
export const STOP_WATCHING_CALL_STATE = "STOP_WATCHING_CALL_STATE";

// Call control actions
export const CALL_STARTED = "call/STARTED";
export const CALL_DISCONNECTED = "call/DISCONNECTED";
export const CALL_FAILED = "call/FAILED";
export const CALL_CLEAR = "call/CLEAR";
export const CALL_AUTH_NEEDED = "call/AUTH_NEEDED";
export const CALL_AUTH_FAILED = "call/AUTH_FAILED";
export const CALL_PARTICIPANT_IDENTIFIED = "call/PARTICIPANT_IDENTIFIED";

export const CALL_STARTED_RECORDING = "call/CALL_STARTED_RECORDING";
export const CALL_STOPPED_RECORDING = "call/CALL_STOPPED_RECORDING";

export const CALL_START_SETTINGS = "call/START_SETTINGS";
export const CALL_STOP_SETTINGS = "call/STOP_SETTINGS";
export const CALL_SETTINGS_PUBLISH = "call/SETTINGS_PUBLISH";
export const CALL_SETTINGS_SWITCH_DEVICE = "call/SETTTINGS_SWITCH_DEVICE";
export const CALL_SETTINGS_PUBLISH_SUCCESS = "call/SETTINGS_PUBLISH_SUCCESS";
export const CALL_SETTINGS_PUBLISH_FAILURE = "call/SETTINGS_PUBLISH_FAILURE";
export const CALL_SETTINGS_UNPUBLISH_SUCCESS = "call/SETTINGS_UNPUBLISH_SUCCESS";
export const CALL_SETTINGS_UNPUBLISH_FAILURE = "call/SETTINGS_UNPUBLISH_FAILURE";
export const CALL_SETTINGS_UPDATE_AUDIO_VIDEO = "call/SETTINGS_UPDATE_AUDIO_VIDEO";

export const CALL_SETTINGS_SET_DEVICES_SUCCESS = "call/SETTINGS_SET_DEVICES_SUCCESS";
export const CALL_SETTINGS_SET_DEVICES_FAILURE = "call/SETTINGS_SET_DEVICES_FAILURE";

export const CALL_PUBLISH_SUCCESS = "call/START_PUBLISH_SUCCESS";
export const CALL_PUBLISH_FAILURE = "call/START_PUBLISH_FAILURE";
export const CALL_UNPUBLISH_SUCCESS = "call/START_UNPUBLISH_SUCCESS";
export const CALL_UNPUBLISH_FAILURE = "call/START_UNPUBLISH_FAILURE";

export const CALL_PEER_JOINED = "call/PEER_JOINED";
export const CALL_PEER_LEFT = "call/PEER_LEFT";

export const CALL_UPDATE_ARCHIVE_STATUS = "call/UPDATE_ARCHIVE_STATUS";

export const CALL_TOGGLE_LOCAL_RECORDING = "call/CALL_TOGGLE_LOCAL_RECORDING";
export const CALL_INITIATE_LOCAL_RECORDING = "call/CALL_INITIATE_LOCAL_RECORDING";
export const CALL_STOP_LOCAL_RECORDING = "call/CALL_STOP_LOCAL_RECORDING";
export const CALL_PARTICIPANT_STARTED_LOCALLY_RECORDING = "call/CALL_PARTICIPANT_STARTED_LOCALLY_RECORDING";
export const CALL_LOCAL_RECORDING_UPLOAD_PENDING = "call/CALL_LOCAL_RECORDING_UPLOAD_PENDING";
export const CALL_LOCAL_RECORDING_UPLOAD_INFO = "call/CALL_LOCAL_RECORDING_UPLOAD_INFO";
export const CALL_LOCAL_RECORDING_SINGLE_PART_INFO = "call/CALL_LOCAL_RECORDING_SINGLE_PART_INFO";
export const CALL_LOCAL_RECORDING_PART_DONE_RECORDING = "call/CALL_LOCAL_RECORDING_PART_DONE_RECORDING";
export const CALL_LOCAL_RECORDING_UPLOAD_START = "call/CALL_LOCAL_RECORDING_UPLOAD_START";
export const CALL_LOCAL_RECORDING_UPLOAD_COMPLETION = "call/CALL_LOCAL_RECORDING_UPLOAD_COMPLETION";
export const CALL_LOCAL_RECORDING_UPLOAD_FAILED = "call/CALL_LOCAL_RECORDING_UPLOAD_FAILED";
export const CALL_LOCAL_RECORDING_PART_UPLOAD_FAILED = "call/CALL_LOCAL_RECORDING_PART_UPLOAD_FAILED";
export const CALL_LOCAL_RECORDING_PART_UPLOAD_SUCCESS = "call/CALL_LOCAL_RECORDING_PART_UPLOAD_SUCCESS";

export const CALL_STATE_UPDATED = "call/CALL_STATE_UPDATED";

export const CALL_MUTE_ALL = "call/MUTE_ALL";

export const CALL_PEER_SPEAKING = "call/PEER_SPEAKING";

export const CALL_PEER_STREAM_LOST = "call/PEER_STREAM_LOST";
export const CALL_PEER_STREAM_BACK = "call/PEER_STREAM_BACK";

export const CALL_SCREEN_SHARE_CAP = "call/SCREEN_SHARE_CAP";
export const CALL_SCREEN_SHARING = "call/SCREEN_SHARING";
export const CALL_SCREEN_SHARE_EXT = "call/SCREEN_SHARE_EXT";

export const CALL_SWITCH_DEVICE = "call/SWITCH_DEVICE";
export const CALL_SEND_MESSAGE = "call/SEND_MESSAGE";
export const CALL_SEND_PEER_INFO = "call/SEND_PEER_INFO";
export const CALL_SENT_MESSAGE = "call/SENT_MESSAGE";
export const CALL_SEND_INFO_MESSAGE = "call/CALL_SEND_INFO_MESSAGE";
export const CALL_RECEIVED_MESSAGE = "call/RECEIVED_MESSAGE";
export const CALL_RECEIVED_INFO_MESSAGE = "call/CALL_RECEIVED_INFO_MESSAGE";
export const CALL_SEND_CHAT_HISTORY_MESSAGE = "call/CALL_SEND_CHAT_HISTORY_MESSAGE";
export const CALL_RECEIVED_CHAT_HISTORY_MESSAGE = "call/CALL_RECEIVED_CHAT_HISTORY_MESSAGE";
export const CALL_RECEIVED_PEER_INFO = "call/CALL_RECEIVED_PEER_INFO";
export const CALL_REQUEST_PEER_INFO = "call/CALL_REQUEST_PEER_INFO";
export const CALL_SET_VIDEO_PARTICIPANTS = "call/SET_VIDEO_PARTICIPANTS";
export const CALL_FLUSH_LOCAL_RECORDING = "call/FLUSH_LOCAL_RECORDING";
export const CALL_LOCAL_RECORDING_CAPABILITY_DETERMINED = "call/CALL_LOCAL_RECORDING_CAPABILITY_DETERMINED";
export const CALL_PARTICIPANT_STORAGE_QUOTA_DETERMINED = "call/CALL_PARTICIPANT_STORAGE_QUOTA_DETERMINED";

// Triggered by user
export const CALL_INIT = "call/INIT";
export const CALL_FINISH = "call/FINISH";
export const CALL_TOGGLE_RECORDING = "call/TOGGLE_RECORDING";
export const CALL_TOGGLE_MICROPHONE = "call/TOGGLE_MICROPHONE";
export const CALL_TOGGLE_CAMERA = "call/TOGGLE_CAMERA";
export const CALL_TOGGLE_CHAT = "call/TOGGLE_CHAT";
export const CALL_TOGGLE_PEER_AUDIO = "call/TOGGLE_PEER_AUDIO";
export const CALL_TOGGLE_PEER_VIDEO = "call/TOGGLE_PEER_VIDEO";
export const CALL_CHECK_SCREEN_SHARE = "call/CHECK_SCREEN_SHARE";
export const CALL_SCREEN_SHARE_FAILED = "call/SCREEN_SHARE_FAILED";
export const CALL_STOP_SCREEN_SHARING = "call/STOP_SCREEN_SHARING";
export const CALL_START_SCREEN_SHARING = "call/START_SCREEN_SHARING";
export const CALL_SET_PEER_RESOLUTION = "call/SET_PEER_RESOLUTION";
export const CALL_SET_PEER_FRAME_RATE = "call/SET_PEER_FRAME_RATE";
export const CALL_SET_PASSWORD = "call/SET_PASSWORD";
export const CALL_DIAL_IN_ENABLED = "call/CALL_DIAL_IN_ENABLED";
export const CALL_SHOW_LOCAL_RECORDING_STATUS = "call/SHOW_LOCAL_RECORDING_STATUS";

// clips
export const CLIPS_LOADING = "CLIPS_LOADING";
export const CLIPS_LOADED = "CLIPS_LOADED";
export const CLIPS_SET_PAGE_VIEW = "CLIPS_SET_PAGE_VIEW";
export const CLIPS_RESET_CURRENT = "CLIPS_RESET_CURRENT";
export const CLIPS_SORT_SETTING = "CLIPS_SORT_SETTING";
export const CLIPS_UPDATE_ONE = "CLIPS_UPDATE_ONE";

// Organization
export const ORGANIZATIONS_LOADED = "organization/ALL_LOADED";
export const ORGANIZATIONS_LOADING = "organization/ORGANIZATIONS_LOADING";
export const ONE_ORGANIZATION_LOADED = "organization/LOADED";
export const ONE_ORGANIZATION_UPDATED = "organization/UPDATED";
export const ORGANIZATION_RESET_USERS = "organization/ORGANIZATION_RESET_USERS";
export const ORGANIZATION_PROJECTS_RESET_CURRENT = "organization/ORGANIZATION_PROJECTS_RESET_CURRENT";
export const UPDATE_ORG_LOGO = "UPDATE_ORG_LOGO";
export const NEW_ORG_LOGO = "NEW_ORG_LOGO";

// Conclude Page
export const CONCLUDE_LOADING = "CONCLUDE_LOADING";
export const CONCLUDE_LOADED = "CONCLUDE_LOADED";
export const UPDATE_CONCLUDE = "UPDATE_CONCLUDE";
export const UPDATE_PREPSESSION = "UPDATE_PREPSESSION";
export const REFRESH_IMAGE = "REFRESH_IMAGE";
export const CLEAN_CONCLUDE = "CLEAN_CONCLUDE";
export const ERROR_WHILE_SAVING = "ERROR_WHILE_SAVING";
export const IS_SAVING_VALUES = "IS_SAVING_VALUES";
export const TRANSCRIBE_SUBMITTED = "TRANSCRIBE_SUBMITTED";

// Daily Call
export const DAILY_CALL_STATUS_CREATING = "DAILY_CALL_STATUS_CREATING";
export const DAILY_CALL_STATUS_CREATED = "DAILY_CALL_STATUS_CREATED";
export const DAILY_CALL_STATUS_SET_USER_DATA = "DAILY_CALL_STATUS_SET_USER_DATA";
export const DAILY_CALL_STATUS_JOINING = "DAILY_CALL_STATUS_JOINING";
export const DAILY_CALL_STATUS_SET_ROOM_DATA = "DAILY_CALL_STATUS_SET_ROOM_DATA";
export const DAILY_CALL_STATUS_JOINED = "DAILY_CALL_STATUS_JOINED";
export const DAILY_CALL_STATUS_JOINED_MEETING = "DAILY_CALL_STATUS_JOINED_MEETING";
export const DAILY_CALL_RESET_CURRENT = "DAILY_CALL_RESET_CURRENT";
export const DAILY_CALL_SHOW_TESTIMONIAL_QUESTIONS = "DAILY_CALL_SHOW_TESTIMONIAL_QUESTIONS";
export const DAILY_CALL_SHOW_RECORD_SETTINGS = "DAILY_CALL_SHOW_RECORD_SETTINGS";
export const DAILY_CALL_UPDATE_PARTICIPANTS = "DAILY_CALL_UPDATE_PARTICIPANTS";
export const DAILY_CALL_RECORDING_STATE = "DAILY_CALL_RECORDING_STATE";
export const DAILY_CALL_UPDATE_NUMBER_RECORDINGS = "DAILY_CALL_UPDATE_NUMBER_RECORDINGS";
export const DAILY_CALL_HIDE_PARTICIPANT_VIDEO = "DAILY_CALL_HIDE_PARTICIPANT_VIDEO";
export const DAILY_CALL_SIDE_PANEL_STATE = "DAILY_CALL_SIDE_PANEL_STATE";
export const DAILY_UPDATE_INVITE_MODAL_STATE = "DAILY_UPDATE_INVITE_MODAL_STATE";

// Galleries

export const GALLERIES_LOADING = "GALLERIES_LOADING";
export const GALLERIES_LOADED = "GALLERIES_LOADED";
export const GALLERIES_GET_SYNC_STATUS = "GALLERIES_GET_SYNC_STATUS";
export const GALLERY_DETAILS_LOADED = "GALLERY_DETAILS_LOADED";
export const GALLERY_DETAILS_LOADING = "GALLERY_DETAILS_LOADING";
export const GALLERY_SET_PUBLIC_PAGE = "GALLERY_SET_PUBLIC_PAGE";
export const GALLERY_UPDATING_PUBLIC_PAGE = "GALLERY_UPDATING_PUBLIC_PAGE";
export const GALLERY_SET_INITIAL_STATE = "GALLERY_SET_INITIAL_STATE";

export const REMIXES_LOADING = "REMIXES_LOADING";
export const REMIXES_LOADED = "REMIXES_LOADED";

// Portals
export const PORTALS_LOADING = "PORTALS_LOADING";
export const PORTALS_LOADED = "PORTALS_LOADED";
export const PORTAL_DETAILS_LOADING = "PORTAL_DETAILS_LOADING";
export const PORTAL_DETAILS_LOADED = "PORTAL_DETAILS_LOADED";
export const PORTAL_CONTENT_LOADED = "PORTAL_CONTENT_LOADED";
export const PORTAL_CONTENT_SELECTION_LOADED = "PORTAL_CONTENT_SELECTION_LOADED";
export const PORTAL_CONTENT_TITLE_UPDATED = "PORTAL_CONTENT_TITLE_UPDATED";
export const PORTAL_CONTENT_VISIBILITY_UPDATED = "PORTAL_CONTENT_VISIBILITY_UPDATED";
export const PORTAL_THUMBNAIL_UPDATED = "PORTAL_THUMBNAIL_UPDATED";
export const PORTAL_UPDATED = "PORTAL_UPDATED";
export const PORTAL_DELETED = "PORTAL_DELETED";
export const PORTAL_AUTOSAVE_STATUS_SET = "PORTAL_AUTOSAVE_STATUS_SET";
export const PORTAL_PUBLISH_PROGRESS_LOADED = "PORTAL_PUBLISH_PROGRESS_LOADED";
export const PORTAL_CONTENT_REPROCESSES_LOADED = "PORTAL_CONTENT_REPROCESSES_LOADED";

// Careful reader will notice that "just interviewee" and "all except interviewer" are
// very different from each other. The former is what we've intended to implement and
// what we present to the user in the UI.  The latter is what we had initially implemented
// under the hood and hence confusion with our users (which resulted in #391).
// Unfortunately, without some extra DB migrations, we can't change "allExceptInterviewer"
// easily as it's already been in the field and stored in DB. For clarity in reading the
// rest of this file, these constants are being redefined here above.
export const ArchiveLayout = {
  ALL: "all",
  JUST_INTERVIEWEE: "allExceptInterviewer",
};
